import React from 'react';
import type { PickerSelectProps, Item as PickerItem } from 'react-native-picker-select';

/**
 * Implementação Web pura (<select>) para RNPickerSelect.
 * Mantém o mesmo import:
 *    import RNPickerSelect from 'react-native-picker-select'
 */
export default function RNPickerSelectWeb(props: PickerSelectProps) {
  const {
    items,
    value,
    onValueChange,
    placeholder,
    disabled,
    style,
    ...rest
  } = props;

  // Placeholder opcional aparece como primeira opção
  const options: PickerItem[] = placeholder
    ? [
        {
          ...placeholder,
          key: 'placeholder',
          label: (placeholder as PickerItem).label ?? '', // Ensure label is always a string
        } as PickerItem,
        ...items,
      ]
    : items;

  const flattenedStyle = (style?.inputWeb ||
    style?.inputIOS ||
    style?.inputAndroid ||
    {}) as React.CSSProperties;

  return (
    <select
      value={value ?? ''}
      onChange={e => {
        const select = e.target as HTMLSelectElement;
        onValueChange(select.value === '' ? null : select.value, 0);
      }}
      disabled={disabled}
      style={{
        padding: 8,
        borderWidth: 0,
        borderRadius: 4,
        background: "transparent",
        ...(flattenedStyle as any)
      }}
      {...rest}
    >
      {options.map(opt => (
        <option
          key={opt.key ?? String(opt.value ?? opt.label)}
          value={opt.value ?? ''}
          label={opt.label}
        >
          {opt.label}
        </option>
      ))}
    </select>
  );
}
